import * as yup from 'yup';
import strings from '../Globalization/index';
import consts from '../consts';
import Model from '../models/model';

const model = new Model({
	name: 'TaskType',
	gridTitle: 'TaskType',
	defaultSort: 'TaskTypeId',
	formTitleField: 'TaskName',
	headerFilterApplyTrigger: 'onChange',
	showGridRefreshBtn: true,
	title: 'TaskType',
	idProperty: '_id',
	comboTypes: [
		{ type: 'TaskType', loaded: true },
		{ type: 'EquipmentFamily', loaded: true }
	],
	formGroups: [
		{
			fields: [
				'TypeId',
				'TaskName',
				'EquipmentFamilyId',
				'TaskDescription',
				'RecommendedFrequency',
				'CycleName',
				'IsAutoComplete'
			]
		}
	],
	columns: [
		{
			header: 'EquipmentFamily',
			field: 'familyId',
			formField: 'EquipmentFamilyId',
			headerFilterField: 'familyId',
			width: 200,
			headerFilter: true,
			standaloneHeaderFilter: true,
			required: true,
			filterColSize: 5,
			lookup: 'EquipmentFamily',
			onClose: () => { } //Validation Override
		},
		{
			header: 'UniqueId',
			field: 'TaskTypeId',
			width: 120,
			hide: true,
			isNotformfield: true
		},
		{
			header: 'EquipmentFamily',
			field: 'EquipmentFamilyName',
			width: 200,
			isNotformfield: true
		},
		{
			header: 'TaskType',
			field: 'TaskType',
			formField: 'TypeId',
			width: 200,
			ignoreLookupOnGridFilter: true,
			required: true,
			lookup: 'TaskType',
			onChange: ({ formik, value }) => {
				if (value === consts.TaskType.Maintenance && formik?.values?.IsAutoComplete) {
					formik.setFieldValue('IsAutoComplete', false, true);
				}
				if (
					formik?.values?.TypeId === consts.TaskType.Maintenance ||
					(formik?.values?.TypeId === consts.TaskType.Indicator && Boolean(formik?.values?.CycleName))
				) {
					formik.setFieldValue('CycleName', '', true);
				}
			}
		},
		{ header: 'Task', field: 'TaskName', maxLength: 100, width: 270, required: true },
		{ field: 'TaskDescription', width: 350, maxLength: 100, required: true },
		{
			field: 'CycleName',
			width: 140,
			maxLength: 100,
			validate: yup
				.string()
				.nullable()
				.when('TypeId', (TypeIds, schema) => {
					if (![consts.TaskType.Maintenance, consts.TaskType.Indicator].includes(TypeIds[0])) {
						return schema.required(strings.requiredField);
					}
					return schema;
				}),
			required: ({ formik }) =>
				formik?.values?.TypeId !== consts.TaskType.Maintenance &&
				formik?.values?.TypeId !== consts.TaskType.Indicator,

			readOnly: ({ formik }) => formik?.values?.TypeId === consts.TaskType.Maintenance || formik?.values?.TypeId === consts.TaskType.Indicator

		},
		{ field: 'RecommendedFrequency', width: 200, maxLength: 200, required: true },
		{
			field: 'IsAutoComplete',
			width: 140,
			type: 'bool',
			disabled: [
				{
					field: 'TypeId',
					op: ({ value }) => {
						return value === consts.TaskType.Maintenance; //Disable for Department Role
					}
				}
			]
		}
	]
});

export default model.createFormBase();